import angular from 'angular';
import autoCompleteModule from './autocomplete/autocomplete';
import whenScrolledModule from './when-scrolled/when-scrolled';
import ModalResponseController from './modal-response/modal-response.controller';
import ModalVideoController from './modal-video/modal-video.controller';
import OfflineModalController from './offline-modal/offline-modal.controller';
import ModalRecommendProductController from './modal-recommend-product/modal-recommend-product.controller';
import restrictType from './restrict-type/restrict-type';
import sessionModule from './session/session';
import MenuDropdownModule from './menu-dropdown/menu-dropdown';
import BannersModule from './banners/banners';
import ModalMapController from './modal-map/modal-map.controller';
import ModalDriverController from './modal-driver/modal-driver.controller';
import ModalSelectClientController from './modal-select-client/modal-select-client.controller';
import staticViews from './static-views/static-views';

let sharedComponentsModule = angular.module('shared.components', [
  autoCompleteModule.name,
  whenScrolledModule.name,
  MenuDropdownModule.name,
  BannersModule.name,
  staticViews.name,
  sessionModule.name
])
  .controller('ModalResponseController', ModalResponseController)
  .directive('restrictType', restrictType)
  .controller('OfflineModalController', OfflineModalController)
  .controller('ModalSelectClientController', ModalSelectClientController)
  .controller('ModalMapController', ModalMapController)
  .controller('ModalDriverController', ModalDriverController)
  .controller('ModalRecommendProductController', ModalRecommendProductController)
  .controller('ModalVideoController', ModalVideoController)
  .filter('toTrusted', ['$sce', function($sce){
    return function(text) {
      return $sce.trustAsHtml(text);
    };
  }]);


export default sharedComponentsModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/components/shared-components.js
 **/